import { defineStore } from 'pinia';

interface AssetState {
  logoUrl: string;
  productUrls: string[];
  creativeS3Url: string;
  startCanvasUpload?: boolean;
}

export const useAssetStore = defineStore('asset', {
  state: ():AssetState => ({
    logoUrl: '',
    productUrls: [] as string[],
    creativeS3Url: '',
    startCanvasUpload: false
  }),
  actions: {
    setLogoUrl(url: string): void {
      this.logoUrl = url;
    },
    setProductUrls(urls: string[]): void {
      this.productUrls = urls;
    },
    resetAssets(): void {
      this.logoUrl = '';
      this.productUrls = [];
    },
    setCreativeS3Url(url: string): void {
      this.creativeS3Url = url;
    },
    setStartCanvasUpload(value: boolean): void {
      this.startCanvasUpload = value;
    }
  },
});
